/**
 * File to hold all our VueJS mixins
 */

Vue.mixin({
  methods: {
    loading(isLoading, ref=null) {
      // console.log('Vue.mixin::loading', isLoading, ref);
      if (isLoading && this.loader == null) {
        this.loader = this.$loading.show({
          container: ref,
          color: '#469BBA',
        });
      } else if (this.loader !== null) {
        this.loader.hide();
        this.loader = null;
      }
    },
  },
});
